<template>
  <a :class="linkClass" @click="onClick">
    <font-awesome-icon v-if="icon" :icon="icon" />
    <span v-if="icon">&nbsp;&nbsp;</span>
    <span class="StdLink__content">
      <slot></slot>
    </span>
  </a>
</template>

<script>
import fas from '@fortawesome/fontawesome-free-solid'
import FontAwesomeIcon from '@fortawesome/vue-fontawesome'

export default {
  components: {
    FontAwesomeIcon,
  },
  props: {
    context: {
      type: String,
      default: 'dark',
    },
    icon: {
      type: String,
      default: '',
    },
    onClick: {
      type: Function,
      default: () => {},
    },  
  },
  computed: {
    fas() { return fas },
    linkClass() {
      return `StdLink StdLink--${this.context}`
    }
  },
}
</script>

<style scoped>
.StdLink {
  cursor: pointer;
  font-weight: 700;
  margin: 0;
  transition: opacity 0.2s;
}

.StdLink:hover {
  opacity: 0.4;
}

.StdLink__content {
  text-decoration: underline;
}

.StdLink--dark {
  color: #3c4148;
  cursor: pointer;
}

.StdLink--light {
  color: #FFF;
  cursor: pointer;
}
</style>





// WEBPACK FOOTER //
// src/components/StdLink/StdLink.vue